<template>
  <div v-if="isChristmasThemeEnabled" class="snow-container">
    <div v-for="i in snowflakeCount" :key="i" class="snowflake">❄</div>
  </div>
</template>

<script setup>
import { useFeature } from '@/composables/use-feature';

const { isChristmasThemeEnabled } = useFeature();

// Number of snowflakes to generate
const snowflakeCount = 50;
</script>

<style lang="scss" scoped>
.snow-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
  overflow: hidden;
}

.snowflake {
  position: absolute;
  top: -10px;
  color: #fff;
  font-size: 1.5em;
  font-family: Arial, sans-serif;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.8);
  animation: fall linear infinite;
  opacity: 0.9;

  &:nth-child(1) {
    left: 10%;
    animation-duration: 8s;
    animation-delay: 0s;
  }
  &:nth-child(2) {
    left: 20%;
    animation-duration: 10s;
    animation-delay: 1s;
  }
  &:nth-child(3) {
    left: 30%;
    animation-duration: 12s;
    animation-delay: 2s;
  }
  &:nth-child(4) {
    left: 40%;
    animation-duration: 9s;
    animation-delay: 0.5s;
  }
  &:nth-child(5) {
    left: 50%;
    animation-duration: 11s;
    animation-delay: 1.5s;
  }
  &:nth-child(6) {
    left: 60%;
    animation-duration: 13s;
    animation-delay: 2.5s;
  }
  &:nth-child(7) {
    left: 70%;
    animation-duration: 8.5s;
    animation-delay: 0.7s;
  }
  &:nth-child(8) {
    left: 80%;
    animation-duration: 10.5s;
    animation-delay: 1.2s;
  }
  &:nth-child(9) {
    left: 90%;
    animation-duration: 12.5s;
    animation-delay: 2.2s;
  }
  &:nth-child(10) {
    left: 5%;
    animation-duration: 9.5s;
    animation-delay: 1.8s;
  }

  @for $i from 11 through 50 {
    &:nth-child(#{$i}) {
      left: #{random(100) * 1%};
      animation-duration: #{8 + random(5)}s;
      animation-delay: #{random(3)}s;
    }
  }
}

@keyframes fall {
  to {
    transform: translateY(100vh) translateX(100px);
    opacity: 0;
  }
}
</style>
